import React from 'react';
import { decorate, observable } from "mobx";
import CardContent from '@material-ui/core/CardContent';
import ActionModel from "../../../../../models/ActionModel/ActionModel";
import NewActionHeader from '../../NewAction/NewActionHeader/NewActionHeader';
import { I18n } from 'aws-amplify';
import TextInput from "../../NewAction/inputs/TextInput/TextInput";

class PostmatesAction extends ActionModel {
	static metadata = {
		id: "postmates",
		name: "Postmates",
		icon: "https://postmates.com/assets/badges/pm-black-square.png",
		categories: {
			// food: true
		}
	};

	Title = "Postmates";
	Link = "https://www.postmates.com/"
	ButtonText = "GO";
	isValid = false

	onValidateUrl = () => {
		this.isValid = true
	}

	getConfigCardBody(cardModel, handleOnChangeIcon) {
		return (
			<CardContent>
				<NewActionHeader
					onChangeIcon={handleOnChangeIcon}
					actionModel={this} />

				<TextInput
					type={'text'}
					field={'Link'}
					label={I18n.get("_action_type_url")}
					store={this}
					disabled={cardModel.loading}
					showRequiredHelperText={I18n.get("_required", "Required")}
				/>
			</CardContent>
		)
	}

	getRules() {
		return {
			Link: {
				presence: { allowEmpty: false },
				url: { message: I18n.get("_action_wrong_link", "Wrong link") }
			},
			...super.getRules()
		}
	}
}

decorate(PostmatesAction, {
	Link: observable,
	isValid: observable,
	Title: observable,
	ButtonText: observable
})

export default PostmatesAction
